import advisorProfiles from './advisorProfiles'
import daiOptOuts from './daiOptOuts'
import governanceProjects from './governanceProjects'
import organizationCompanies from './organizationCompanies'
import organizations from './organizations'
import organizationUsers from './organizationUsers'
import regulations from './regulations'
import regulationVersions from './regulationVersions'
import userProfiles from './userProfiles'
import users from './users'

const backoffice = {
  advisorProfiles,
  daiOptOuts,
  governanceProjects,
  organizationCompanies,
  organizations,
  organizationUsers,
  regulations,
  regulationVersions,
  userProfiles,
  users,
}

export default backoffice
